/**
 * Status vocabulary shared by the Material Hunt pages. Labels are the
 * user-facing framing ("Looking for an answer", never raw enum values); the
 * server's status column is the source of truth.
 */
export const statusLabel = status => {
  switch (status) {
    case 'confirmed':
      return 'Identified';
    case 'likely_identified':
      return 'Likely identified';
    case 'closed':
      return 'Closed';
    case 'rejected':
      return 'Removed';
    case 'analyzing':
      return 'Analysing';
    case 'open':
    default:
      return 'Looking for an answer';
  }
};
